import React from "react";
import { FiFileText, FiMail, FiAlertTriangle, FiCheckSquare } from "react-icons/fi";

interface NotificationStatCardsProps {
  total: number;
  unread: number;
  priorityCount: number;
  reviewRequiredCount: number;
  selectedFilter: 'all' | 'unread' | 'priority' | 'review';
  onSelectFilter: (filter: 'all' | 'unread' | 'priority' | 'review') => void;
}

const NotificationStatCards: React.FC<NotificationStatCardsProps> = ({
  total,
  unread,
  priorityCount,
  reviewRequiredCount,
  selectedFilter,
  onSelectFilter
}) => {
  const cards = [
    {
      id: "all" as const,
      label: "Total",
      value: total,
      icon: FiFileText,
      iconColor: "text-[#58CC02]",
      bgColor: "bg-[#58CC02]/[0.08]"
    },
    {
      id: "unread" as const,
      label: "Unread",
      value: unread,
      icon: FiMail,
      iconColor: "text-blue-500",
      bgColor: "bg-blue-50"
    },
    {
      id: "priority" as const,
      label: "Priority",
      value: priorityCount,
      icon: FiAlertTriangle,
      iconColor: "text-amber-500",
      bgColor: "bg-amber-50"
    },
    {
      id: "review" as const,
      label: "Review Required",
      value: reviewRequiredCount,
      icon: FiCheckSquare,
      iconColor: "text-[#58CC02]",
      bgColor: "bg-[#58CC02]/[0.08]"
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
      {cards.map(card => {
        const Icon = card.icon;
        const isSelected = selectedFilter === card.id;

        return (
          <div
            key={card.id}
            onClick={() => onSelectFilter(card.id)}
            className={`flex items-center gap-4 p-4 rounded-xl border transition-all duration-200 cursor-pointer select-none ${
              isSelected
                ? "bg-[#010D2C] border-[#010D2C] shadow-md scale-[1.01]"
                : "bg-white border-gray-200 hover:border-gray-300 hover:shadow-sm"
            }`}
          >
            <div className={`p-3 rounded-lg shrink-0 transition-colors ${
              isSelected ? "bg-white/10" : card.bgColor
            }`}>
              <Icon className={`w-6 h-6 transition-colors ${
                isSelected ? "text-white" : card.iconColor
              }`} />
            </div>
            <div>
              <p className={`text-xs font-semibold uppercase tracking-wider transition-colors ${
                isSelected ? "text-slate-300" : "text-gray-500"
              }`}>
                {card.label}
              </p>
              <p className={`text-2xl font-black mt-1 font-montserrat transition-colors ${
                isSelected ? "text-white" : "text-[#010D2C]"
              }`}>
                {card.value}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default NotificationStatCards;
